const KYC_STATUS = {
  unverified : 'Unverified',
  kyc_ready: 'KYC Ready',
  pending_verification: 'Pending Verification',
  unable_to_verify: 'Unable to Verify',
  kyc_approved: 'KYC Approved'
 };
 
 export default KYC_STATUS;